import type { Locale } from "@/i18n";

interface ServiceCopy {
  title: string;
  line: string;
  badge?: string;
}

const en: readonly ServiceCopy[] = [
  {
    title: "Software development",
    line: "We have built the app for a checkout-free store, a bank's web shop, and a stock-trading interface. For you, we build whatever your company is missing: a new product, an internal system, or an integration between the ones you have. One pair of hands, from design to going live.",
  },
  {
    title: "AI-native solutions",
    line: "An agent that takes over the routine part of the work. Search that actually understands your own material. Document processing that does not fumble every tenth invoice. AI that holds up in production, not just in the demo.",
  },
  {
    title: "AI audit",
    badge: "new service",
    line: "Retyped invoices, a colleague answering the same question all day, the weekly report assembled by hand: all of it can be automated, but not all of it is worth it. The audit ends with numbers showing what would pay off at your company and what would not. If the answer is nothing yet, we say so: we build these systems ourselves, and we know where their limits are.",
  },
];

const hu: readonly ServiceCopy[] = [
  {
    title: "Szoftverfejlesztés",
    line: "Építettünk már személyzet nélküli bolthoz appot, banki webáruházat és tőzsdei kereskedési felületet. Neked azt, ami a cégedből hiányzik: új terméket, belső rendszert vagy integrációt a meglévőid közé. Egy kézben, a tervezéstől az üzembe állításig.",
  },
  {
    title: "AI-natív megoldások",
    line: "Ágens, ami elvégzi a munka rutin részét. Kereső, ami a te anyagaidat érti, nem a fél internetet. Dokumentumfeldolgozás, ami nem hibázza el minden tizedik számlát. Olyan AI, ami a napi használatban is megállja a helyét, nem csak a bemutatón.",
  },
  {
    title: "AI-audit",
    badge: "új szolgáltatás",
    line: "A begépelt számlák, az ugyanarra válaszolgató kolléga, a kézzel összerakott heti riport: mind automatizálható, de nem mind éri meg. Az audit végén számokban látod, nálad mi hozna pénzt és mi nem. Ha egyelőre semmi, azt is kimondjuk: mi építjük ezeket a rendszereket, tudjuk, hol vannak a határaik.",
  },
];

export const SERVICES: Record<Locale, readonly ServiceCopy[]> = {
  en,
  hu,
};

export const SERVICES_LABEL: Record<Locale, string> = {
  en: "What We Do",
  hu: "Amit csinálunk",
};

export const ADVISORY_NOTE: Record<Locale, string> = {
  en: "Advisory work too: architecture reviews, AI capability assessment, build versus buy. Always as an independent expert who owns the answer, never as a team member slotted under an internal manager.",
  hu: "Tanácsadást is vállalunk: átvizsgáljuk az architektúrát, felmérjük, mire jó nálad az AI, és megmondjuk, mikor érdemes saját fejlesztésbe kezdeni, mikor elég egy kész termék. Önálló szakértőként dolgozunk, és amit tanácsolunk, azért felelünk is. Nem leszünk a csapatod tagjai, belső menedzser alá beosztva.",
};
